import { Link } from "react-router-dom"
import Logo from "../components/Logo"
import Card from "../components/Card"
import visibility from '../assets/visibility.svg'
import Button from "../components/Button"
import useForm from "../useForm"
import usePassword from "../usePassword"


function ResetPassword() {
  const {handleChange, values, handleSubmit, errors, message, errmsg} = useForm({
    new_password: '',
    confirm_new_password: ''
  });
  const {showPassword, handlePasswordToggle, showConfirmPassword, handleConfirmPasswordToggle} = usePassword(false);
  return (
    <div className='login-container'>
    <Logo />
    <Card>
    {message ? <p className="text-success my-3 message">{message}</p> : 
    <p className="text-danger my-3">{errmsg}</p>}
       <h4 className="card-head">
          Create New Password
      </h4>
       <p className="card-text"> 
       Enter your new password below to  your Payourl account.
       </p>
       <form onSubmit={handleSubmit}>
          <div className="password-input-group">
              <input 
              className={errors.confirm_new_password ? "error login-input gen-input" : "login-input gen-input"} 
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              id="new-password"
              name="new_password"
              value={values.new_password}
              onChange={handleChange} />
                <img
                 className='visibility' 
                 src={visibility} 
                 onClick={handlePasswordToggle}
                 alt="eye" />
          </div>
          {errors.new_password && <p className="small">{errors.new_password}</p>}
          <div className="password-input-group">
              <input 
              className={errors.confirm_new_password ? "error login-input gen-input" : "login-input gen-input"}
              type={showConfirmPassword ? "text" : "password"}
              placeholder=" Confirm Password"
              id="confirm-new-password"
              name="confirm_new_password"
              value={values.confirm_new_password}
              onChange={handleChange} />
                <img
                 className='visibility' 
                 src={visibility} 
                 onClick={handleConfirmPasswordToggle}
                 alt="eye" 
                 />
          </div>
          {errors.confirm_new_password && <p className="small">{errors.confirm_new_password}</p>}
          <Button  disabled={errors.confirm_new_password} type='submit'>
              Reset Password
          </Button>
       </form>

        <div className="no-account">
            <p>Remember Password?</p>
            <Link to='/login' className="link-text sign-up-link">
                Sign in
            </Link>
        </div>
    </Card> 
</div>
  )
}

export default ResetPassword